export const help: object = {
  help: {
    getHelp: 'Hilfe erhalten',
    contactUs: 'Kontaktiere Uns'
  }
};
